"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Hash: function() {
        return Hash;
    },
    default: function() {
        return _default;
    }
});
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var __generator = (void 0) && (void 0).__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var Hash = /*#__PURE__*/ function() {
    "use strict";
    function Hash() {
        _classCallCheck(this, Hash);
    }
    var _proto = Hash.prototype;
    /**
     * Checks if the passed string equals the stored hash.
     *
     * @param key
     * @param hash
     */ _proto.areHashesEqual = function areHashesEqual(key, hash) {
        var _this = this;
        return _asyncToGenerator(function() {
            var storedItem;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!_this.isHashTimestampValid(key)) {
                            return [
                                2,
                                false
                            ];
                        }
                        storedItem = _this.getHash(key);
                        if (!storedItem) {
                            return [
                                2,
                                false
                            ];
                        }
                        if (storedItem.hash === hash) {
                            return [
                                2,
                                true
                            ];
                        }
                        return [
                            4,
                            _this.createHash(hash)
                        ];
                    case 1:
                        // If not, check if we need to hash the compared string as well.
                        hash = _state.sent();
                        return [
                            2,
                            storedItem.hash === hash
                        ];
                }
            });
        })();
    };
    /**
     * Store a hash with a specific key, for a specific time.
     *
     * Example, to store a hash for 30 days (2592000s)
     *
     * @example ```js
     * new Hash.storeHash('modal-opened', "This is the content we are hashing that defines if the modal is changes", 2592000)
     * ```
     *
     * @param {string} key The key to store the hash at
     * @param {string} hashTarget The data to hash.
     * @param {number} expiresIn The time to expire in. Defaults to 7 days.
     */ _proto.storeHash = function storeHash(key, hashTarget) {
        var expiresIn = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 604800;
        var _this = this;
        return _asyncToGenerator(function() {
            var hash;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this.createHash(hashTarget)
                        ];
                    case 1:
                        hash = _state.sent();
                        window.localStorage.setItem(key, JSON.stringify({
                            hash: hash,
                            expiresAt: new Date().getTime() / 1000 + expiresIn
                        }));
                        return [
                            2
                        ];
                }
            });
        })();
    };
    /**
     * Create a hash from a string.
     *
     * @param hashTarget
     */ _proto.createHash = function createHash(hashTarget) {
        return crypto.subtle.digest("SHA-256", new TextEncoder().encode(hashTarget)).then(function(h) {
            var hexes = [];
            var view = new DataView(h);
            for(var i = 0; i < h.byteLength; i += 4){
                hexes.push(("00000000" + view.getUint32(i).toString(16)).slice(-8));
            }
            return hexes.join("");
        });
    };
    /**
     * Delete a hash from storage
     * @param key
     */ _proto.deleteHash = function deleteHash(key) {
        var item = this.storageObject.getItem(key);
        if (!item) {
            return;
        }
        window.localStorage.removeItem(key);
    };
    _proto.isHashTimestampValid = function isHashTimestampValid(key) {
        var hashObject = this.getHash(key);
        if (!hashObject) {
            return false;
        }
        if (!hashObject.expiresAt) {
            return true;
        }
        var now = new Date().getTime() / 1000;
        var isExpired = hashObject.expiresAt <= now;
        if (isExpired) {
            this.deleteHash(key);
        }
        return !isExpired;
    };
    _proto.getHash = function getHash(key) {
        var item = this.storageObject.getItem(key);
        if (!item) {
            return false;
        }
        return JSON.parse(item);
    };
    _createClass(Hash, [
        {
            key: "storageObject",
            get: function get() {
                return "localStorage" in window ? window.localStorage : new Storage();
            }
        }
    ]);
    return Hash;
}();
var Storage = /*#__PURE__*/ function() {
    "use strict";
    function Storage() {
        _classCallCheck(this, Storage);
        this.storage = new Map();
    }
    var _proto = Storage.prototype;
    _proto.getItem = function getItem(key) {
        return this.storage.get(key);
    };
    _proto.setItem = function setItem(key, data) {
        this.storage.set(key, data);
    };
    _proto.removeItem = function removeItem(key) {
        this.storage.delete(key);
    };
    return Storage;
}();
var _default = Hash;
